import { Context } from '@/models/order-history/status/context/context'
import { paymentTypeIsExternalPayment } from '@/models/order-history/status/context/payment-type'
import {
  ReorderAcceptabilityState,
  reorderNotAcceptableState,
} from '@spa/components/organisms/mypage/order/model/reorder-acceptability-state'
import { createReorderPaymentPath } from '@spa/components/organisms/mypage/order/model/reorder-acceptability-state/create-reorder-path'
import { CreateStateCommand } from '@spa/components/organisms/mypage/order/model/reorder-acceptability-state/create-state-command'

interface ApplicableContext extends Context {
  paymentType: 'carrier' | 'webmoney' | 'creditcard3d'
}

/**
 * @internal モジュールの外部からはgetReorderAcceptabilityStateを利用すること
 */
export class CreateStateCommandForExternalPayment extends CreateStateCommand<ApplicableContext> {
  shouldApply(context: Context): context is ApplicableContext {
    return paymentTypeIsExternalPayment(context.paymentType)
  }
  protected createState(context: ApplicableContext): ReorderAcceptabilityState {
    switch (context.engineStatus) {
      case 'payment-requested':
      case 'payment-error':
        return {
          id: 're-payment-for-external-payment',
          acceptable: true,
          createReorderPath: createReorderPaymentPath,
          view: {
            title: '決済がまだ完了していません',
            buttonLabel: '決済を再開する',
            description: [
              'お支払い時にエラーなどがあった場合は、以下のボタンから決済を再開していただけます。',
              'ご注文から1時間以上決済が確認できない場合、自動でキャンセルさせていただきますのでご注意ください。',
            ],
          },
        }
      default:
        return reorderNotAcceptableState
    }
  }
}
